"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedBuilderEx = void 0;
var utils_1 = require("./utils");
var EmbedClientEx_1 = require("./EmbedClientEx");
var EmbedBuilderEx = /** @class */ (function () {
    function EmbedBuilderEx(_sdk, _type, _endpoint) {
        this._sdk = _sdk;
        this._type = _type;
        this._endpoint = _endpoint;
        this._handlers = {};
        this._appendTo = null;
        this._sandboxAttrs = [];
        this._allowAttrs = [];
        this._classNames = [];
        this._frameBorder = '0';
        this._params = {};
        this._ariaLabel = '';
    }
    EmbedBuilderEx.prototype.withFrameBorder = function (attr) {
        this._frameBorder = attr;
        return this;
    };
    EmbedBuilderEx.prototype.withId = function (id) {
        if (this.endpoint === '') {
            throw new Error('withId requires initialization of endpoint');
        }
        this._id = id;
        return this;
    };
    EmbedBuilderEx.prototype.withParams = function (params) {
        for (var key in params) {
            this._params[key] = params[key];
        }
        return this;
    };
    EmbedBuilderEx.prototype.withFilters = function (filters, escape) {
        if (escape === void 0) { escape = false; }
        if (this.type === 'dashboards') {
            for (var key in filters) {
                this._params[key] = escape
                    ? (0, utils_1.escapeFilterParam)(filters[key])
                    : filters[key];
            }
        }
        else {
            for (var key in filters) {
                this._params["f[".concat(key, "]")] = escape
                    ? (0, utils_1.escapeFilterParam)(filters[key])
                    : filters[key];
            }
        }
        return this;
    };
    EmbedBuilderEx.prototype.withSandboxAttr = function () {
        var attr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            attr[_i] = arguments[_i];
        }
        this._sandboxAttrs = this._sandboxAttrs.concat(attr);
        return this;
    };
    EmbedBuilderEx.prototype.withAllowAttr = function () {
        var attr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            attr[_i] = arguments[_i];
        }
        this._allowAttrs = this._allowAttrs.concat(attr);
        return this;
    };
    EmbedBuilderEx.prototype.withClassName = function () {
        var className = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            className[_i] = arguments[_i];
        }
        this._classNames = this._classNames.concat(className);
        return this;
    };
    EmbedBuilderEx.prototype.withTheme = function (theme) {
        this._params.theme = theme;
        return this;
    };
    EmbedBuilderEx.prototype.withScrollMonitor = function (monitor) {
        if (monitor === void 0) { monitor = true; }
        this._scrollMonitor = monitor;
        return this;
    };
    EmbedBuilderEx.prototype.withDynamicIFrameHeight = function (dynamicIFrameHeight) {
        if (dynamicIFrameHeight === void 0) { dynamicIFrameHeight = true; }
        this._dynamicIFrameHeight = dynamicIFrameHeight;
        return this;
    };
    EmbedBuilderEx.prototype.withDialogScroll = function (dialogScroll) {
        if (dialogScroll === void 0) { dialogScroll = true; }
        this._dialogScroll = dialogScroll;
        return this;
    };
    EmbedBuilderEx.prototype.withApiHost = function (apiHost) {
        if (!this._sdk.apiHost) {
            this._sdk.apiHost = apiHost;
            if (this.sandboxedHost) {
                this._params.embed_domain = apiHost;
                this._params.sandboxed_host = 'true';
            }
        }
        else if (this._sdk.apiHost !== apiHost) {
            throw new Error('not allowed to change api host');
        }
        return this;
    };
    EmbedBuilderEx.prototype.withAuthUrl = function (authUrl) {
        var _a;
        if (((_a = this._sdk.auth) === null || _a === void 0 ? void 0 : _a.url) === '') {
            this._sdk.auth = { url: authUrl };
        }
        else if (this._sdk.auth.url !== authUrl) {
            throw new Error('not allowed to change auth url');
        }
        return this;
    };
    EmbedBuilderEx.prototype.withAuth = function (auth) {
        var _a;
        if (((_a = this._sdk.auth) === null || _a === void 0 ? void 0 : _a.url) === '') {
            this._sdk.auth = __assign({}, auth);
        }
        else if (this._sdk.auth !== auth) {
            throw new Error('not allowed to change auth url');
        }
        return this;
    };
    EmbedBuilderEx.prototype.withUrl = function (url) {
        this._url = (0, utils_1.santizeEmbedUrl)(url);
        return this;
    };
    EmbedBuilderEx.prototype.withAllowLoginScreen = function () {
        this._allowLoginScreen = true;
        return this;
    };
    EmbedBuilderEx.prototype.withAriaLabel = function (ariaLabel) {
        this._ariaLabel = ariaLabel;
        return this;
    };
    /**
     * @deprecated
     */
    EmbedBuilderEx.prototype.withNext = function (_) {
        return this;
    };
    Object.defineProperty(EmbedBuilderEx.prototype, "sandboxedHost", {
        get: function () {
            if (this._sandboxedHost === undefined) {
                var embedHostDomain = window.location.origin;
                this._sandboxedHost = embedHostDomain === 'null' || !embedHostDomain;
            }
            return this._sandboxedHost;
        },
        set: function (sandboxedHost) {
            this._sandboxedHost = sandboxedHost;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "el", {
        get: function () {
            return this._appendTo || document.body;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "frameBorder", {
        get: function () {
            return this._frameBorder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "endpoint", {
        get: function () {
            return this._endpoint;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "type", {
        get: function () {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "ariaLabel", {
        get: function () {
            return this._ariaLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "apiHost", {
        get: function () {
            return this._sdk.apiHost;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "isCookielessEmbed", {
        get: function () {
            return !!this._sdk.acquireSession && !!this._sdk.generateTokens;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "acquireSession", {
        get: function () {
            return this._sdk.acquireSession;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "generateTokens", {
        get: function () {
            return this._sdk.generateTokens;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "auth", {
        get: function () {
            return this._sdk.auth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "embedUrl", {
        get: function () {
            var params = (0, utils_1.stringify)(this._params);
            if (this._url) {
                var sep = '';
                if (params.length > 0) {
                    sep = this._url.includes('?') ? '&' : '?';
                }
                return "".concat(this.endpoint).concat(this._url).concat(sep).concat(params);
            }
            else {
                var sep = params.length === 0 ? '' : '?';
                return "".concat(this.endpoint, "/").concat(this.id).concat(sep).concat(params);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "handlers", {
        get: function () {
            return this._handlers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "sandboxAttrs", {
        get: function () {
            return this._sandboxAttrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "allowAttrs", {
        get: function () {
            return this._allowAttrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "classNames", {
        get: function () {
            return this._classNames;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "scrollMonitor", {
        get: function () {
            return this._scrollMonitor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "dynamicIFrameHeight", {
        get: function () {
            return this._dynamicIFrameHeight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "dialogScroll", {
        get: function () {
            return this._dialogScroll;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmbedBuilderEx.prototype, "allowLoginScreen", {
        get: function () {
            var _a;
            return (this._allowLoginScreen && !this.isCookielessEmbed && !((_a = this._sdk.auth) === null || _a === void 0 ? void 0 : _a.url));
        },
        enumerable: false,
        configurable: true
    });
    EmbedBuilderEx.prototype.appendTo = function (el) {
        if (typeof el === 'string') {
            this._appendTo = document.querySelector(el);
        }
        else {
            this._appendTo = el;
        }
        return this;
    };
    EmbedBuilderEx.prototype.on = function (name, handler) {
        this._handlers[name] = this._handlers[name] ? this._handlers[name] : [];
        this._handlers[name].push(handler);
        return this;
    };
    EmbedBuilderEx.prototype.build = function () {
        return new EmbedClientEx_1.EmbedClientEx(this._sdk, this);
    };
    return EmbedBuilderEx;
}());
exports.EmbedBuilderEx = EmbedBuilderEx;
//# sourceMappingURL=EmbedBuilderEx.js.map